import { valorEhNulo, valorVazio, valorEhCelular, valorEhTelefone, valorEhCnpj, valorEhCpf } from '@/util/index'
import { obterMascaraCnpj } from '@/util/cnpjMask'

const QUANTIDADE_CARACTERES_CPF = 11
const REGEX_CARACTERES_NAO_ALFANUMERICOS = /[^A-Za-z0-9]/g
const REGEX_LETRA = /[A-Za-z]/

const normalizarDocumentoParaMascara = (valor) => {
  return valor.toString().replace(REGEX_CARACTERES_NAO_ALFANUMERICOS, '')
}

const documentoTemLetra = (documento) => {
  return REGEX_LETRA.test(documento)
}

const documentoUltrapassaQuantidadeCpf = (documento) => {
  return documento.length > QUANTIDADE_CARACTERES_CPF
}

const deveUsarMascaraCnpj = (valor) => {
  const documentoNormalizado = normalizarDocumentoParaMascara(valor)
  return documentoTemLetra(documentoNormalizado) || valorEhCnpj(valor) || documentoUltrapassaQuantidadeCpf(documentoNormalizado)
}

export const mascaraTelefoneCelular = (valor) => {
  if (valorEhNulo(valor) || valorVazio(valor)) {
    return null
  }

  if (valorEhCelular(valor)) {
    return mascarasParaCampos.celular
  }

  if (valorEhTelefone(valor)) {
    return mascarasParaCampos.telefone
  }
}

export const mascaraCEP = (valor) => {
  if (valorEhNulo(valor) || valorVazio(valor)) {
    return null
  }

  return mascarasParaCampos.cep
}

const mascaraCpfCnpj = (valor) => {
  if (valorEhNulo(valor) || valorVazio(valor)) {
    return null
  }

  if (deveUsarMascaraCnpj(valor)) {
    return obterMascaraCnpj(valor)
  } else if (valorEhCpf(valor)) {
    return mascarasParaCampos.cpf
  }
}

export const mascaraMonetaria = (valor) => {
  if (valorEhNulo(valor) || valorVazio(valor)) {
    return null
  }

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2

  })
  const valorFormatado = formatter.format(valor)
  return valorFormatado
}

export const mascarasParaCampos = {
  telefone: '(##) ####-####',
  celular: '(##) #####-####',
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##',
  cep: '#####-###'
}

export default {
  mascaraTelefoneCelular,
  mascarasParaCampos,
  mascaraCpfCnpj,
  mascaraCEP,
  mascaraMonetaria
}
